import { categories } from "@/mocks/guagua";
import SectionHeading from "./SectionHeading";

function Categories() {
  return (
    <section
      id="category"
      className="w-full bg-background-100 py-14 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="主题分类"
          title="按兴趣快速逛瓜"
          desc="从明星八卦到民生趣闻，六大热门分类帮你精准锁定感兴趣的话题，一键直达对应事件现场与视频合集。"
          linkHref="#video"
          linkLabel="查看全部视频"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#video"
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="relative h-32 md:h-40 w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name}热点视频分类`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute right-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs whitespace-nowrap text-background-50">
                  {cat.hot}
                </span>
              </div>

              <div className="flex flex-1 flex-col items-center gap-2 px-3 py-4">
                <span className="grid h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={cat.icon} aria-hidden="true"></i>
                </span>
                <span className="text-sm md:text-base font-medium text-foreground-800">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500">
                  {cat.count.toLocaleString()} 条瓜点
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;